export default __webpack_public_path__ + "static/media/ESSK38LSIA01.b7cf1c2c.mp4";